import {
  AlertCircle,
  Bell,
  Clock,
  GitBranch,
  Mail,
  MessageSquare,
  Settings,
} from 'lucide-react';

const STEP_TYPES = {
  send_email: { label: 'Send Email', icon: Mail, color: 'blue' },
  email_action: { label: 'Send Email', icon: Mail, color: 'blue' },
  send_sms: { label: 'Send SMS', icon: MessageSquare, color: 'green' },
  sms: { label: 'Send SMS', icon: MessageSquare, color: 'green' },
  wait: { label: 'Wait', icon: Clock, color: 'amber' },
  delay: { label: 'Wait', icon: Clock, color: 'amber' },
  condition: { label: 'If/Else', icon: GitBranch, color: 'purple' },
  if_else: { label: 'If/Else', icon: GitBranch, color: 'purple' },
  branch: { label: 'If/Else', icon: GitBranch, color: 'purple' },
  send_notification: { label: 'Internal Notification', icon: Bell, color: 'cyan' },
  internal_notification: { label: 'Internal Notification', icon: Bell, color: 'cyan' },
  backend_action: { label: 'Backend Action', icon: Settings, color: 'orange' },
  action: { label: 'Backend Action', icon: Settings, color: 'orange' },
};

function normalizeStepType(type) {
  return String(type || '').trim().toLowerCase();
}

export function resolveWorkflowStepTypeConfig(step) {
  const rawType = normalizeStepType(step?.type);
  const config = STEP_TYPES[rawType];
  if (config) return config;
  if (step?.config?.requires_backend) {
    return { label: 'Required Backend Action', icon: AlertCircle, color: 'orange' };
  }
  return { label: 'Backend Action', icon: Settings, color: 'orange' };
}
